export default [
  [`Размер`, `2XS`, `XS`, `S`, `M`, `L`, `XL`],
  [`Российский размер`, `40`, `42`, `44`, `46`, `48`, `50`],
  [`Рост, см`, `168-176`, `168-176`, `168-176`, `168-176`, `168-176`, `168-176`]
];
